module.exports = __webpack_public_path__ + "static/jade7-52d4bab2b36ba6b324196b657d756f26.png";